var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoRefrescar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29.87 30",
    style: {
      enableBackground: "new 0 0 29.87 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.reloadIcon{fill:#7367F0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-reload",
    className: "reloadIcon",
    d: "M14.91,0C6.63,0.05-0.05,6.8,0,15.09S6.8,30.05,15.09,30c3.93-0.02,7.69-1.58,10.48-4.35 l-2.7-2.7c-4.39,4.41-11.51,4.42-15.92,0.04S2.52,11.47,6.9,7.07c2.11-2.12,4.98-3.31,7.97-3.32c2.97,0.02,5.8,1.26,7.84,3.41 l-4.09,4.09h11.25V0l-4.46,4.46C22.63,1.63,18.84,0.03,14.87,0H14.91z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoRefrescar);
export default __webpack_public_path__ + "static/media/icono-refrescar.0de224599b17392380b0c09839e0fcc5.svg";
export { ForwardRef as ReactComponent };